import { ajax } from "rxjs/ajax";
import { catchError } from "rxjs/operators";
import { throwError } from "rxjs";

import { RequestError, NotFoundError } from "./error";

const host = process.env.VUE_APP_HOST;

const handleError = err => {
  // eslint-disable-next-line no-console
  console.error(err);
  // TODO: handle 404 not found
  // since api haven't implement, so we have not idea the 404 response schema is.
  // so not handle it now.
  if (err instanceof NotFoundError) {
    return throwError(new NotFoundError(err));
  }
  return throwError(new RequestError(err));
};

export class ApiClient {
  fetchBanners() {
    return ajax.getJSON(`${host}/api/banner`).pipe(catchError(handleError));
  }
  fetchNewsList(type, offset = 0, limit = 8) {
    const page = Math.floor(offset / limit) + 1;
    return ajax
      .getJSON(`${host}/api/news?type=${type}&page=${page}&size=${limit}`)
      .pipe(catchError(handleError));
  }

  fetchNews(id) {
    return ajax.getJSON(`${host}/api/news/${id}`).pipe(catchError(handleError));
  }

  fetchTeachers(level) {
    return ajax
      .getJSON(`${host}/api/teacher?school_level=${level}`)
      .pipe(catchError(handleError));
  }

  fetchCourseSchedule(schoolLevel) {
    return ajax
      .getJSON(`${host}/api/course-schedule?level=${schoolLevel}`)
      .pipe(catchError(handleError));
  }

  fetchRanks(type) {
    return ajax
      .getJSON(`${host}/api/rank?type=${type}`)
      .pipe(catchError(handleError));
  }
}

const apiClient = new ApiClient();

export const withApiClient = component => {
  const computed = component.computed || {};
  return {
    ...component,
    computed: {
      apiClient: () => {
        return apiClient;
      },
      ...computed
    }
  };
};
